import type { BadgeProps } from '../../design/primitives/Badge';
import type { PrimeStatus } from '../../types/prime.types';

export const MAX_FAMILY = 5;

/** Status → badge-visning (kontrakt §5.8). Frontend viser kun; backend leverer status. */
export const MEMBER_STATUS: Record<PrimeStatus, { label: string; tone: NonNullable<BadgeProps['tone']> }> = {
  active: { label: 'Aktivt medlemskab', tone: 'success' },
  invited: { label: 'Inviteret', tone: 'warning' },
  deactivated: { label: 'Deaktiveret', tone: 'danger' },
};

/** Fordele hardcodes i frontend (kontrakt §5.10 — intet endpoint). */
export const BENEFITS: string[] = [
  '20% på alle produkter — gælder hele husstanden',
  'Fri fragt på parkstyling.dk',
  'Fødselsdagstilbud: 2 produkter for 1 produkts pris',
  'Udvidet tilfredshedsgaranti i 180 dage',
  'Op til 5 gratis familiemedlemmer',
];
